import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import Rating from 'static-components/src/vue/rating/rating.vue';
import { vueCustomElementOptions } from 'static-components/src/vue-customelement-options';
import { store } from "ltur-state-engine";
import HotelRatingTripadvisor from "Rating/hotel-rating-tripadvisor.vue";
var initializeRating = function () {
    var state = store.getState();
    var market = state.websiteState.app.url.context.country.toLowerCase();
    Vue.use(VueCustomElement);
    // @ts-ignore
    if (market !== 'fr')
        Vue.customElement('c-rating', (new Rating().$options), vueCustomElementOptions);
    else
        Vue.customElement('c-rating', (new HotelRatingTripadvisor().$options), vueCustomElementOptions);
};
export default initializeRating;
